import { Flex, Typography, List, RemoteImage } from '@banhala/ui-kit';
import React from 'react';
import { SearchType } from 'shared/src/api/enums';
import { useLogSearchKeyword } from '../../hook/useLogSearchKeyword';
import { bridge, isNotEmpty } from 'shared/src/utils';
import { useOpenDeeplink } from 'shared/src/hooks';
import { Accessibility } from '../../../../utils/accessibility';

export interface BeautyItem {
  name: string;
  badge: string;
  query?: string;
  nudging_text?: string;
  deeplink?: string;
}

type Props = {
  item_list: BeautyItem[];
  onPress: (item: BeautyItem) => void;
};

export const BeautyList = ({ item_list, onPress }: Props) => {
  const logSearchKeyword = useLogSearchKeyword();
  const { openDeeplink } = useOpenDeeplink();
  const width = 64;
  const radius = width / 2;
  return (
    <List
      horizontal
      data={item_list}
      keyExtractor={(item, index) => `${item.name}-${index}`}
      showsHorizontalScrollIndicator={false}
      keyboardShouldPersistTaps="handled"
      contentContainerStyle={{
        paddingHorizontal: 16,
        paddingVertical: 4,
      }}
      renderItem={({ item, index }: { item: BeautyItem; index: number }) => {
        const hasNudging = isNotEmpty(item.nudging_text);
        return (
          <Flex
            testID={Accessibility.Search.beautyCategoryListItem(item.name, index)}
            width={72}
            margin={{ right: 12 }}
            alignItems="center"
            onPress={async () => {
              // 딥링크가 있으면 딥링크 이동 (searchKeyword 로깅 안함)
              if (item.deeplink) {
                bridge.logAnalyticsEvent({
                  name: 'CLICK_EVENT_ICON',
                  channel: ['firebase', 'amplitude', 'facebook', 'ablylog'],
                  analytics: {
                    SCREEN: 'SEARCH',
                    DEEPLINK: item.deeplink,
                    CTA_NAME: item.name,
                  },
                });
                openDeeplink(item.deeplink);
                return;
              }

              // query가 있으면 검색 실행
              if (item.query) {
                logSearchKeyword({
                  searchType: SearchType.BEAUTY_RECOMMEND,
                  keyword: item.query,
                  clickIndex: index,
                });
                onPress(item);
              }
            }}
          >
            <Flex
              width={width}
              height={width}
              borderRadius={radius}
              borderWidth={hasNudging ? 2 : 1}
              borderColor={hasNudging ? 'pink30' : 'border_tertiary'}
              backgroundColor="gray10"
              margin={{ bottom: 8 }}
              justifyContent="center"
              alignItems="center"
              overflow="hidden"
            >
              <RemoteImage uri={item.badge} width={width} height={width} />
            </Flex>
            {hasNudging && (
              <Flex
                padding={{ horizontal: 5, vertical: 3 }}
                borderRadius={8}
                backgroundColor="content_pink_primary"
                margin={{ bottom: 4 }}
              >
                <Typography type="subtitle7" color="content_always_white">
                  {item.nudging_text}
                </Typography>
              </Flex>
            )}
            <Typography type="body2" textAlign="center">
              {item.name}
            </Typography>
          </Flex>
        );
      }}
    />
  );
};
